var popups = function () {

  var publicMethods = {};

	var links = document.querySelectorAll('a.js-popup-launch');

	var bodyElement;
	var popupLoader;
	var popupFade;

	var offset = 75;

  publicMethods.init = function() {

		if (!links.length) return;

		injectHTML();
    
    for (var i = 0; i < links.length; i++) {
			
			(function (i) { links[i].addEventListener('click', handleLinkClick); })(i);
		
		}

		closeLinks();

  };

	function injectHTML() {

		bodyElement = document.querySelector('body');
		bodyElement.insertAdjacentHTML('beforeend', '<div id="popupFade" class="no-print js-close" /><div id="popupLoader" class="no-print" />');
		popupLoader = document.querySelector('#popupLoader');
		popupFade = document.querySelector('#popupFade');

	};

	function handleLinkClick(e) {

		var link = e.target;
		var href = link.getAttribute('href');
		var template = link.hasAttribute('data-template') ? link.getAttribute('data-template') : null;
		open(href, template);
		e.preventDefault();

	};

	function open(url, template) {

		loader();

		if (typeof template === 'undefined' || template === null) { template = '#popupLaunchTemplate'; }
		template = document.querySelector(template).innerHTML;
		template = Hogan.compile(template);

		fetch(url).then(function (response) {

			return response.text();

		}).then(function (html) {

			var div = document.createElement('div');
			div.innerHTML = html;
			var content = div.querySelector('#popupContentWrapper');

			if (!content) {

				location.href = url;
				return;

			}

			var rendered = template.render({
				content: content.innerHTML,
				url: url
			});

			bodyElement.insertAdjacentHTML('beforeend', rendered);

			var p = document.querySelector('.m-popup[data-href="' + url + '"]');
			p.style.top = getTop();

			p.style.display = 'block';

			loader(true);

			analytics.page(url, 'Popup');

		}).catch(function (e) {
			
			location.href = url;
			throw new Error(e);

		});

	};

	function loader(hide) {

		if (hide) {

			popupLoader.style.display = 'none';
			return;

		}

		popupLoader.style.display = 'block';
		popupFade.style.display = 'block';

	};

	function getTop() {

		var top = window.scrollY;
		return parseInt(top += offset, 10) + 'px';

	};

	function closeLinks() {

		document.body.addEventListener('click', function (e) {
			
			if (e.target.classList.contains('js-close')) {

				var p = document.querySelector('.m-popup');

				if (p) {
					
					p.remove();
					popupFade.style.display = 'none';

				}

			}

		});

	};

  return publicMethods;

}();

popups.init();